export const DescriptionToCsvByActionType = ({ rowData, i18n }) => {
    const { actions } = rowData;
    const action = actions[0];
    const { actionType, budgetAdditionalData } = action;
    const messageId = budgetAdditionalData
        ? `performance.rule.report.description.${actionType}.${budgetAdditionalData.changeType}`
        : `performance.rule.report.description.${actionType}`;
    return i18n.formatMessage(
        {
            id: messageId,
        },
        {
            actionType,
            ...budgetAdditionalData,
            currency: '$',
        }
    );
};
